export default __webpack_public_path__ + "static/media/saw-logo.38981fbf.png";